module.exports = __webpack_public_path__ + "static/media/hands.b27fa679.svg";